import { render } from "./addpayment_culinary.vue?vue&type=template&id=4549371a"
import script from "./addpayment_culinary.vue?vue&type=script&lang=js"
export * from "./addpayment_culinary.vue?vue&type=script&lang=js"

import "./addpayment_culinary.vue?vue&type=style&index=0&id=4549371a&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__